import { useLoadScript } from '@react-google-maps/api'

import I18n from 'lib/i18n'

import { GOOGLE_MAP_API_KEY } from '~/scenes/settings'

export const useMapsApiLoader = options =>
  useLoadScript({
    googleMapsApiKey: GOOGLE_MAP_API_KEY,
    language: I18n.locale,
    version: 'weekly',
    ...options
  })
